import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  isUploadingPicture,
  isUploadedPicture,
  getUploadPictureError,
  isVerified,
} from './upload-picture.selectors';
import { UploadPictureActions } from '@fantaz/user-verification/data-access';
import { isVerifying } from '../verify-user/verify-user.selectors';

@Injectable({
  providedIn: 'root',
})
export class UploadPictureFacade {
  private store = inject(Store);

  /**
   * State for the  verification running process
   *
   * @returns Observable<boolean>
   */
  isUploadingPicture$ = this.store.select(isUploadingPicture);
  isPictureUploaded$ = this.store.select(isUploadedPicture);
  isPictureVerified$ = this.store.select(isVerified);
  isVerifyingPicture$ = this.store.select(isVerifying);
  errorUploadingPicture$ = this.store.select(getUploadPictureError);
  cleanState$ = () => this.store.dispatch(UploadPictureActions.resetState());
  uploadToS3 = (file: File) =>
    this.store.dispatch(UploadPictureActions.uploadPicture({ file }));
  openUploadPictureDialog = () =>
    this.store.dispatch(UploadPictureActions.showUploadPictureDialog());
  validateImage = () =>
    this.store.dispatch(UploadPictureActions.verifyWithPicture());
}
